export type NitroPadSize = 'small' | 'big';

export interface NitroPadSpec {
  distance: number;
  pad: NitroPadSize;
}

/**
 * Places whole clusters of 5 nitro checkpoints on a closed lap.
 * The last pad of the finish cluster sits on the start/finish line (distance 0)
 * so lap order stays index 0 = finish. Other clusters sit on the racing line
 * with a clear gap so the triggers do not stack.
 */
export function layoutNitroPads(length: number): NitroPadSpec[] {
  const lap = Math.max(80, length);
  let spacing = 14;
  let clusters = 4;
  const span = (gap: number) => gap * 4;
  const need = (count: number, gap: number) => span(gap) * count + 36 * Math.max(0, count - 1) + 80;
  while (clusters > 2 && need(clusters, spacing) > lap) clusters -= 1;
  while (spacing > 10 && need(clusters, spacing) > lap) spacing -= 1;

  const pads: NitroPadSpec[] = [];
  const pushCluster = (start: number, finishLine: boolean) => {
    for (let i = 0; i < 5; i += 1) {
      let distance = start + i * spacing;
      if (finishLine && i === 4) distance = 0;
      else distance = ((distance % lap) + lap) % lap;
      pads.push({ distance, pad: i === 4 ? 'big' : 'small' });
    }
  };

  const clusterSpan = span(spacing);
  pushCluster(lap - clusterSpan, true);

  const regionStart = 40;
  const regionEnd = lap - clusterSpan - 36;
  let interior = clusters - 1;
  const gapFor = (count: number) => (regionEnd - regionStart - clusterSpan * count) / (count + 1);
  while (interior > 0 && (regionEnd - regionStart < clusterSpan || gapFor(interior) < 28)) interior -= 1;
  if (interior > 0) {
    const gap = gapFor(interior);
    for (let c = 0; c < interior; c += 1) {
      pushCluster(regionStart + gap * (c + 1) + clusterSpan * c, false);
    }
  }

  pads.sort((a, b) => a.distance - b.distance);
  return pads;
}
